import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resource } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class ResourceService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<Resource[]>(URL + 'pss_app/resource/');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/resource.service.ts